import { render, staticRenderFns } from "./exchanger.vue?vue&type=template&id=0b13cd4b&scoped=true&"
import script from "./exchanger.vue?vue&type=script&lang=js&"
export * from "./exchanger.vue?vue&type=script&lang=js&"
import style0 from "./exchanger.vue?vue&type=style&index=0&id=0b13cd4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b13cd4b",
  null
  
)

export default component.exports